import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function FilterIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M17.6972 3H6.30278C5.03099 3 4 4.03099 4 5.30278C4 5.7574 4.13457 6.20186 4.38675 6.58013L9.49615 14.2442C9.82469 14.737 10 15.3161 10 15.9083V20.382C10 21.1253 10.7823 21.6088 11.4472 21.2764L12.3416 20.8292C13.358 20.321 14 19.2822 14 18.1459V15.9083C14 15.3161 14.1753 14.737 14.5038 14.2442L19.6132 6.58013C19.8654 6.20185 20 5.7574 20 5.30278C20 4.03099 18.969 3 17.6972 3Z"
        fill="currentColor"
      />
    </svg>
  )
}
